import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';
import { START } from 'pu-data/QuoteSteps';
import RadioComponent from 'pu-react/components/RadioComponent';
import Tooltip from 'pu-react/components/Tooltip';
import { faComments } from '@fortawesome/free-solid-svg-icons';

class PriceMatrixCell extends React.Component {
  constructor(props) {
    super(props);
    this.unitPrice = this.unitPrice.bind(this);
    this.totalPrice = this.totalPrice.bind(this);
    this.renderInput = this.renderInput.bind(this);
    this.onChange = this.onChange.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.onSelectData = this.onSelectData.bind(this);
    this.renderEmpty = this.renderEmpty.bind(this);
    this.identifier = this.identifier.bind(this);
    this.cellClass = this.cellClass.bind(this);
    this.currentRowIdx = this.currentRowIdx.bind(this);
    this.currentColIdx = this.currentColIdx.bind(this);
  }

  onSelectData() {
    return {
      quantity: this.props.quantity,
      leadTime: this.props.leadTime,
      supplier: this.props.lineItem.product_key,
      parametersChanged: this.props.parametersChanged,
      unitPrice: this.unitPrice(),
      total: this.totalPrice(),
      row_selected: this.currentRowIdx(),
      column_selected: this.currentColIdx(),
    };
  }

  onChange() {
    if (!this.props.onPriceSelect) {
      // TODO: show error and report to managers
      return;
    }
    if (this.totalPrice() <= 0) {
      return;
    }
    this.props.onPriceSelect(this.onSelectData());
  }

  identifier() {
    const supplier = this.props.lineItem.product_key;
    return `${this.props.quantity}-${this.props.leadTime}-${supplier}`;
  }

  totalPrice() {
    const { lineItem } = this.props;
    const row = this.currentRowIdx();
    const col = this.currentColIdx();
    const { pricing } = lineItem;
    if (
      pricing === undefined ||
      row < 0 ||
      col < 0 ||
      pricing[row] === undefined ||
      pricing[row][col] === undefined
    ) {
      return null;
    }
    return pricing[row][col];
  }

  unitPrice() {
    const total = this.totalPrice();
    const unitPrice = total / this.props.quantity;
    // return _.round(unit_price, 2);
    return Math.round(unitPrice * 100) / 100;
  }

  showUnitPrice() {
    return `$${numeral(this.unitPrice()).format('0.00')}`;
  }

  isSelected() {
    const { parameters, lineItem } = this.props;
    if (parameters === undefined) {
      return false;
    }

    return _.parseInt(parameters.row_selected) === this.currentRowIdx() &&
      _.parseInt(parameters.column_selected) === this.currentColIdx() &&
      parameters.supplier_selected === lineItem.product_key;
  }

  cellClass() {
    return '';
  }

  renderEmpty() {
    // const tooltip = <Tooltip id="tooltip">This require a Custom Quote</Tooltip>;
    // return (
    //   <OverlayTrigger placement="top" overlay={tooltip}>
    //     <FontAwesomeIcon icon="comments" />
    //   </OverlayTrigger>
    // )
    return (
      <Tooltip id={`tp-${this.identifier()}`} icon={faComments} title="This require a Custom Quote" />
    );
  }

  renderInput() {
    return (
      <RadioComponent
        inputId={`price-${this.identifier()}`}
        label={this.showUnitPrice()}
        name={this.props.name}
        onChange={this.onChange}
        inputClassName={this.props.inputClassName}
        checked={this.isSelected()} />
    );
  }

  render() {
    const total = this.totalPrice();
    let field;
    if (total == null)
      field = this.renderEmpty();
    else {
      field = this.props.quoteStep === START || total > 0 ?
        this.renderInput() :
        this.renderEmpty();
    }
    return <td className={this.cellClass()}>{field}</td>;
  }

  currentRowIdx() {
    const { lineItem, quantity } = this.props;
    if (!lineItem || !quantity) return -1;
    // return lineItem.get('quantities').findIndex(qty => qty === quantity)
    return lineItem.quantities.indexOf(quantity);
  }

  currentColIdx() {
    const { lineItem, leadTime } = this.props;
    if (!lineItem || !leadTime) return -1;
    // return lineItem.get('lead_times').findIndex(lt => lt === leadTime)
    return lineItem.lead_times.indexOf(leadTime);
  }
}

PriceMatrixCell.defaultProps = {
  name: 'price_matrix',
  inputClassName: 'ignore-on-quote',
};

PriceMatrixCell.propTypes = {
  quantity: PropTypes.number.isRequired,
  leadTime: PropTypes.number.isRequired,
  lineItem: PropTypes.object.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
  parameters: PropTypes.object.isRequired,
  name: PropTypes.string,
  inputClassName: PropTypes.string,
  quoteStep: PropTypes.string.isRequired,
}

export default PriceMatrixCell;
